import { defineStore } from 'pinia'
// import { useI18n } from 'vue-i18n'
// detectLocale, setLocale,
import { update } from '@/api/auth'
import { cloneDeep } from 'lodash'

// const { locale } = useI18n()

export const useAuthStore = defineStore('auth', {
  // convert to a function
  state: (): {
    user: IUser | undefined
    jwt: string
  } => ({
    user: undefined,
    jwt: '',
  }),
  getters: {
    // user and jwt getter removed, no longer needed
    isLoggedIn: (state) => state.user !== undefined,
  },
  actions: {
    // no context as first argument, use `this` instead
    setUser(user: IUser) {
      if (user) this.user = user
      else this.user = undefined
      // locale.value = user.locale || locale.value
    },
    updateUser(user: Partial<IUser>) {
      // if (user.locale) {
      // locale.value = user.locale
      // }

      const payload = { ...this.user, ...cloneDeep(user) } as IUser
      return update(payload).then(() => (this.user = payload))
    },

    // toggle2FA() {
    //   this.is2FAEnabled = !this.is2FAEnabled
    // },

    // changeUserName(userName: string) {
    //   this.userName = userName
    // },
    // easily reset state using `$reset`
    clearUser() {
      this.$reset()
    },
  },
})
